(function() {

  'use strict';

  angular.module('eclipseApp.components').controller('ctnDeactivatePopUpCtrl', ['$scope', '$rootScope', '$state', '$http', 'uteEndpoint', 'commonService', '$modalInstance', '$window', '$timeout', 'data' ,function($scope, $rootScope, $state, $http, uteEndpoint, commonService, $modalInstance, $window, $timeout, data) {
    $scope.account = {};
    $scope.editEmailDiv = true;
    $scope.successDiv = false;
    var accountNumber = $rootScope.userInfo.accounts;
    var errorCode = '';
    var uuid = $rootScope.userInfo.uuid;
    $scope.showCtnModal = false;
    $scope.showGroupIdModal = false;
    errorCode = data.errorCode;
    $scope.timeOut = function(){
      $timeout(function() {
        commonService.logOutUser(false, '', '');
      }, 10000);
    }
    if (errorCode === '560065') {
      $scope.showCtnModal = true;
      $scope.showGroupIdModal = false;
    }
    else {
      $scope.showCtnModal = false;
      $scope.showGroupIdModal = true;
    }
    $scope.register = function() {
    if ($scope.registerEmailForm.$valid) {
      $scope.errorMessage = 'none';
      $scope.error = true;
      $http({
        method: 'POST',
        url: uteEndpoint('v1/wireless/reregister'),
        data: {
            emailAddress: $scope.account.Email,
            accountNumber: accountNumber,
            uuid : uuid
        }
      }).success(function(data) {
      if (_.isEmpty(data)) {
          $scope.errorMessage = 'genericError';
      } else {
          var responseCode = data.reRegistrationResponse.result.responseCode;
          if (responseCode === '1630') {
              $scope.errorMessage = 'numberAlreadyAssociated';
          } else if (responseCode === '1005') {
              $scope.errorMessage = 'emailAlreadyAssociated';
          } else if (responseCode === '1019' || responseCode === '1001') {
              $scope.errorMessage = 'genericError';
          } else if (responseCode === '1000') {
              $scope.editEmailDiv = false;
              $scope.successDiv = true;
              $('.emailRegisteredRecently').html($scope.account.Email);
              $scope.timeOut();
          }
      }
      }).error(function(data,status) {
        if (status === 440) {
          commonService.logOutUser(false, 'global.message.sessionExpiredLoginAgain', 'login');
          $modalInstance.dismiss();
        }
        $scope.errorMessage = 'genericError';
      });
    }

    };
    $scope.closeModalWithLogOut = function(){
      $modalInstance.dismiss();
      commonService.logOutUser(false, '', 'login');
    }
  }]);

})();
